import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-institute',
  templateUrl: './about-institute.component.html',
  styleUrls: ['./about-institute.component.scss']
})
export class AboutInstituteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
